class AjaxGrid {
	constructor(passedElement) {
        let self = this;
        
        self.elem = passedElement;
        self.filters = document.querySelectorAll('.js-ajax-filter');
        self.scrollTo = document.querySelector('.js-ajax-grid-scrollto');
        self.currentPage = 1;
        self.args = {};
	}

	init() {
		let self = this;

        if(self.elem.getAttribute('data-type') === 'news') {
            self.type = "news";
            self.baseUrl = '/news/paginated/';
        } else {
            self.type = "portfolio";
            self.baseUrl = '/current-portfolio/paginated/';
        }
        
        self.load();

        window.addEventListener('orientationchange', function() {
            // Need to delay to get correct breakpoint
            window.setTimeout(function() {
                self.load();
            }, 200);
        })

        if(self.type === "portfolio") {
            self.filters.forEach(element => {
                element.addEventListener('change', function() {
                    self.filterSearch();
                })
            })
        }
    }

    setElements() {
        let self = this;
        self.gridContainer = self.elem.querySelector('.js-ajax-grid-container');
        self.cardContainer = self.elem.querySelector('.js-ajax-card-container');

        self.currentPage = parseInt(self.gridContainer.dataset.currentpage);
        self.totalPages = parseInt(self.gridContainer.dataset.totalpages);
        self.prevBtn = self.elem.querySelectorAll('.js-ajax-prev-btn');
        self.nextBtn = self.elem.querySelectorAll('.js-ajax-next-btn');

        self.addEventListeners();
    }

    addEventListeners() {
        let self = this;

        self.prevBtn.forEach(element => {
            element.addEventListener('click', function() {
                self.loadPrev();
            })
        });

        self.nextBtn.forEach(element => {
            element.addEventListener('click', function() {
                self.loadNext();
            })
        })
    }

    loadPrev () {
        let self = this;
                
        if (self.currentPage > 1) {
            self.currentPage --;
            // self.load();
            self.filterSearch();
            self.scrollToTop();
        }
    }

    loadNext () {
        let self = this;
                
        if (self.currentPage < self.totalPages) {
            self.currentPage ++;
            self.load(self.currentPage);
            self.scrollToTop();
        }
    }
    
    load(args = null) {
        let self = this;
        let limit = self.setLimit();

        if (self.args && self.type === "portfolio") {
            let entries = Object.entries(self.args);
            var argsString;

            for (let i = 0; i < entries.length; i++) {
                if (i == 0) {
                    argsString = '?' + entries[i][0] + '=' + entries[i][1];
                } else {
                    argsString = argsString + '&' + entries[i][0] + '=' + entries[i][1];
                }
            }
        }

        var url = self.baseUrl + limit + '/p' + self.currentPage;

        if (typeof argsString !== 'undefined') {
            url = url + argsString;
        }

        // console.log(url);

        // Set up our HTTP request
        let xhr = new XMLHttpRequest();

        // Setup our listener to process completed requests
        xhr.onload = function () {

            // Process our return data
            if (xhr.status >= 200 && xhr.status < 300) {
                // What do when the request is successful
                self.elem.innerHTML = xhr.response;
                self.setElements();
            } else {
                // What do when the request fails
                console.log('The request failed!');
                // location.reload();
            }

            // Code that should run regardless of the request status
            // console.log('This always runs...');
        };

        // Create and send a GET request
        // The first argument is the post type (GET, POST, PUT, DELETE, etc.)
        // The second argument is the endpoint URL
        xhr.open('GET', url);
        xhr.send();
    }

    filterSearch() {
        let self = this;
        // let args = {};
        self.args = {};

        self.filters.forEach(element => {
            if (element.value != "") {
                self.args[element.name] = encodeURI(element.value);
            }
        });

        // self.load(args);
        self.load();
    }

    getBreakpoint() {
        return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
    }

    setLimit() {
        let self = this;
        let limit = 0;
        const breakpoint = self.getBreakpoint();

        if ( ['xs'].includes(breakpoint) ) {
            return limit = 1;
        }

        if ( ['sm','md'].includes(breakpoint) ) {
            return limit = 8;
        }

        if ( ['lg','xl','xxl'].includes(breakpoint) ) {
            return limit = 9;
        }

        return limit;
    }

    scrollToTop() {
        let self = this;
        self.scrollTo.scrollIntoView();
        window.scrollBy(0, -80); 
    }
}

export default AjaxGrid;